export default __webpack_public_path__ + "static/media/google-icon.8464d0df.svg";